import React, { useRef } from 'react';
import { useEnteredView } from '@fiverr-private/hooks';
import { I18n } from '@fiverr-private/i18n-react';
import { Container } from '@fiverr-private/layout_components';
import { formatBigNumbers } from '@fiverr-private/seller_pages_toolbox';
import { Text } from '@fiverr-private/typography';
import { useOrders } from '../../../hooks/useOrders';
import { useSellerRole } from '../../../hooks/useSellerRole';
import { useBI } from '../../BIContext';

type TotalOrdersProps = Readonly<{ sellerRoleId?: string }>;

export const TotalOrders = ({ sellerRoleId }: TotalOrdersProps) => {
    const observableRef = useRef<HTMLDivElement>(null);
    const { totalCount } = useOrders();
    const sellerRole = useSellerRole(sellerRoleId);
    const { reportSellerHighlightsOrdersImpression } = useBI();

    const label = formatBigNumbers(Number(sellerRole ? sellerRole.completedOrdersCount : totalCount));

    useEnteredView(observableRef, {
        threshold: 1,
        onEntered: () => {
            reportSellerHighlightsOrdersImpression({ label });
        },
    });

    return (
        <Container ref={observableRef}>
            <Text
                size={{
                    default: 'b_lg',
                    md: 'b_xl',
                    lg: 'b_xxl',
                }}
                fontWeight="bold"
                marginBottom="1"
            >
                {label}
            </Text>
            <Text size="b_sm" fontWeight="semibold" color="bodySecondary" whiteSpace="nowrap">
                <I18n
                    k={
                        sellerRole
                            ? 'seller_page_perseus.professions_page.highlights.orders'
                            : 'seller_page_perseus.professions_page.highlights.total_orders'
                    }
                />
            </Text>
        </Container>
    );
};
